import React from "react";
import { Box, Typography } from "@mui/joy";

const styles = {
    root: {
        flex: 1,
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center" as const,
        gap: 0.5,
        py: 8,
        px: 3,
    },
    title: { fontWeight: 600, color: "text.secondary" },
    hint: { color: "text.tertiary" },
    action: { mt: 1 },
};

interface EmptyStateProps {
    title: string;
    hint?: string;
    action?: React.ReactNode;
}

/** Minimal centered empty state — plain canvas, no box, no background wash. */
export default function EmptyState({ title, hint, action }: EmptyStateProps) {
    return (
        <Box sx={styles.root}>
            <Typography level="body-md" sx={styles.title}>
                {title}
            </Typography>
            {hint && (
                <Typography level="body-sm" sx={styles.hint}>
                    {hint}
                </Typography>
            )}
            {action && <Box sx={styles.action}>{action}</Box>}
        </Box>
    );
}
